import { create } from "zustand";
import { PrecisionGameLeaderboard } from "../models/precisionGame.types";

interface PrecisionGameLeaderboardState {
  records: PrecisionGameLeaderboard[] | null;
  winners: PrecisionGameLeaderboard[] | null;
  mentions: PrecisionGameLeaderboard[] | null;
  loading: boolean;
  error: Error | null;
  setRecords: (records: PrecisionGameLeaderboard[]) => void;
  setWinners: (winners: PrecisionGameLeaderboard[]) => void;
  setMentions: (mentions: PrecisionGameLeaderboard[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
}

export const usePrecisionGameLeaderboardStore =
  create<PrecisionGameLeaderboardState>((set) => ({
    records: null,
    winners: null,
    mentions: null,
    loading: true,
    error: null,
    setRecords: (records) => set({ records }),
    setWinners: (winners) => set({ winners }),
    setMentions: (mentions) => set({ mentions }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
  }));
